import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledDayOfWeek = styled.div`
  color: #767676;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 4px;
`;

const StyledDate = styled.div`
  color: #767676;
  font-size: 16px;
  font-weight: 400;
`;

const DateCell = ({ dataTest, date }) => {
  if (!date) return null;

  return (
    <div data-testid={dataTest}>
      <StyledDayOfWeek>{moment.utc(date).format('dddd')}</StyledDayOfWeek>
      <StyledDate>{moment.utc(date).format('MMM D, YYYY')}</StyledDate>
    </div>
  );
};

DateCell.propTypes = {
  dataTest: PropTypes.string,
  date: PropTypes.number.isRequired,
};

export default DateCell;
